import $ from "jquery";

export default function () {
  const $slider = $(".linkedin-posts-slider");

  if (!$slider.length) {
    return;
  }

  const $slides = $slider.find(".linkedin-post-slide");
  const $previous = $slider.find(".linkedin-posts-slider-arrow--prev");
  const $next = $slider.find(".linkedin-posts-slider-arrow--next");

  if ($slides.length <= 1) {
    $previous.hide();
    $next.hide();

    return;
  }

  let currentIndex = 0;

  if (currentIndex == 0) {
    $previous.hide();
  }

  function showSlide(index) {
    currentIndex = index;
    if (index == 0) {
      $previous.hide();
    }
    if (index > 0) {
      $previous.show();
    }
    if (index == $slides.length - 1) {
      $next.hide();
    }
    if (index >= 0 && index < $slides.length - 1) {
      $next.show();
    }

    $slides.removeClass("is-active");
    $slides.eq(currentIndex).addClass("is-active");
  }

  $previous.on("click", function () {
    showSlide(currentIndex - 1);
  });

  $next.on("click", function () {
    showSlide(currentIndex + 1);
  });
}
